import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { SectorDataDDL } from '../../../../Components/CommonDDL/SectorDataDDL';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { AssetDataDDL } from '../../../../Components/CommonDDL/AssetDataDDL';
import { YesNoDataDDL } from '../../../../Components/CommonDDL/YesNoDataDDL';
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { AssetTypeDataDDL } from '../../../../Components/CommonDDL/AssetTypeDataDDL';
import { GardenMasterPostDataAPI } from '../../../../Redux/MasterSlice/GardenMasterSlice';
import { StatusNameDataDDL } from '../../../../Components/CommonDDL/StatusNameDataDDL';
import { AstricSign } from '../../../../Helper/AstricSign';


export default function GardenPopup(props) {

  const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData } = props

  const userDetails = useAuthState();
  const { UserID, token, } = userDetails.user
  const dispatch = useDispatch();

  // const [rowData, setRowData] = useState(rowData)

  const [AreaName, setAreaName] = useState(Flag === 'Update' ? rowData.areaName : '');
  const [Area, setArea] = useState(Flag === 'Update' ? rowData.areaInSquareMetre : '');
  const [AssetName, setAssetName] = useState(Flag === 'Update' ? rowData.assetName : '');
  const [IsOpen, setIsOpen] = useState(false);


  const [SectorName, setSectorName] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.m_gD_SectorID : 0,
    Label: Flag === 'Update' ? rowData.sectorName : "Select...",
  })
  const [WardName, setWardName] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.m_WardID : 0,
    Label: Flag === 'Update' ? rowData.wardName : "Select...",

  })
  const [AssetType, setAssetType] = useState({
    DDL: [],
    ID: M_AssetTypeID,
    Label: Flag === 'Update' ? rowData.assetTypeName : "Select...",
  })
  const [GetPresent, setGetPresent] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.isGetPresent : 0,
    Label: Flag === 'Update' ? rowData.isGetPresentName : "Select...",

  })

  const [WateringEdgesPresent, setWateringEdgesPresent] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.isWateringOfEdgesPresent : 0,
    Label: Flag === 'Update' ? rowData.isWateringOfEdgesPresent : "Select...",
  })
  const [WateringTreePresent, setWateringTreePresent] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.isWateringOfTreesPresent : 0,
    Label: Flag === 'Update' ? rowData.isWateringOfTreesPresent : "Select...",
  })

  const [WateringLawnPresent, setWateringLawnPresent] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.isWateringOfLawnsPresent : 0,
    Label: Flag === 'Update' ? rowData.isWateringOfLawnsPresent : "Select...",

  })
 
  const [Status, setStatus] = useState({
    DDL: [],
    ID: Flag === 'Update' ? rowData.m_StatusID : 0,
    Label: Flag === 'Update' ? rowData.statusName : "Select...",

  })


  useEffect(() => {
    setAreaName(Flag === 'Update' ? rowData.areaName : '')
    setArea(Flag === 'Update' ? rowData.areaInSquareMetre : '')
    setAssetName(Flag === 'Update' ? rowData.assetName : '')
  }, [rowData, IsOpen])

  const handleClearField = () => {

    if (Flag != 'Update') {
      setAreaName('')
      setArea('')
      setAssetName('')
    }
  }

  const handlePost = () => {
    const data = {
      M_AssetID: Flag === 'Update' ? rowData?.m_AssetID : '0',
      M_AssetTypeIDS: AssetType.ID,
      M_GD_SectorID: SectorName.ID,
      AssetName: AssetName,
      AreaName: AreaName,
      AreaInSquareMetre: Area,
      IsGetPresent: GetPresent.ID,
      IsWateringOfEdgesPresent: WateringEdgesPresent.ID,
      IsWateringOfTreesPresent: WateringTreePresent.ID,
      IsWateringOfLawnsPresent: WateringLawnPresent.ID,
      IsMaintingYou: WateringLawnPresent.ID,
      M_StatusID: Status.ID,
      M_UserID: UserID,
      token: token,
      Flag: Flag === 'Update' ? 'Update' : 'Insert',
      handleIsPost: handleIsPost,
      handleClearField: handleClearField,
      handleOnCloseClick: handleOnCloseClick
    }
    dispatch(GardenMasterPostDataAPI({ data }))
  }

  return (
    <Popup
      open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
    >
      <div className='area_pop modal-dialog modal-dialog-scrollable modal-xl pop_heading_zIndex' >
        <div className="modal-content">
          <div className="modal-header pl-4 p-1">
            <h4 className="modal-title" id="staticBackdropLabel">{popupHeading}</h4>
            <button className="btn-close m-1 mr-3" type="button" onClick={handleOnCloseClick} />
          </div>
          <div className="modal-body mx-auto" >
            <div className='inner-modal-body'>
              <div className="row details-row">
                <div className="col-md-6 col-12 col-lg-6">
                  <WardNameDataDDL
                    WardName={WardName}
                    setWardName={setWardName}
                    Flag={Flag}
                    rowData={rowData}
                    SectorName={SectorName}
                    setSectorName={setSectorName}
                  />
                </div>
                <div className="col-md-6 col-12 col-lg-6">
                  <SectorDataDDL
                    SectorName={SectorName}
                    setSectorName={setSectorName}
                    WardName={WardName}
                    rowData={rowData}
                    Flag={Flag}
                  />
                </div>

                <div className="col-md-6 col-12 col-lg-6">
                  <AssetTypeDataDDL
                    AssetType={AssetType}
                    setAssetType={setAssetType}
                    Flag={Flag}
                    rowData={rowData}
                    M_AssetTypeID={M_AssetTypeID}
                    IsDisabled={true}
                  />
                </div>

                <div className="col-md-6 col-12 col-lg-6">
                  <div className="form-group">
                    <label className="d-block" htmlFor="NameofDepartment">Asset Name <AstricSign /> :</label>
                    <input type="text"
                      className="form-control"
                      id="AssetName"
                      value={AssetName}
                      onChange={(e) => setAssetName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12 col-lg-6">
                  <div className="form-group">
                    <label className="d-block" htmlFor="NameofDepartment">Area Name <AstricSign /> :</label>
                    <input type="text"
                      className="form-control"
                      id="AreaName"
                      value={AreaName}
                      onChange={(e) => setAreaName(e.target.value)}

                    />
                  </div>
                </div>
                {
                  GardenMasterFlag == 'GardenMaster' ?
                    <div className="col-md-6 col-12 col-lg-6">
                      <div className="form-group">
                        <label className="d-block" htmlFor="NameofDepartment">Area (in sq meter) <AstricSign /> :</label>
                        <input type="text"
                          className="form-control"
                          id="Area"
                          value={Area}
                          onChange={(e) => setArea(e.target.value)}

                        />
                      </div>
                    </div>
                    :
                    <></>
                }

                <div className="col-md-6 col-12 col-lg-6">
                  <StatusNameDataDDL
                    Status={Status}
                    setStatus={setStatus}
                    rowData={rowData}
                    Flag={Flag}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="btn-action d-flex justify-content-end mt-lg-3">

                  <button type='button'
                    className="btn allBtn  float-right submit_btn"
                    onClick={() => handlePost()}
                    disabled={
                      WardName.ID == 0 || SectorName.ID == 0 || AssetType.ID == 0 || AssetName == '' || AreaName == '' || Area == '' || Status.ID == 0
                    }
                  >{Flag === "Update" ? "Update" : "Save"} </button>

                  <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* )} */}


    </Popup>
  )

}